import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { connect } from 'react-redux'
import { useRouter } from 'next/router'
import { Notification } from 'react-notification'
import { capitalize } from 'SRC/utils'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import Router from 'next/router'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { getCurrentGroup } from 'SRC/modules/groups/selectors'
import { getPaginationParams } from 'SRC/modules/ads/pagination/selectors'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { getInfo } from 'SRC/modules/users/detail/selectors'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { getSearchAsUrl, getSearchHrefUrl, prepareFilterValues } from 'SRC/modules/ads/filter/functions'
import config from 'SRC/config/config.json'

const PanelMobile = ({
  filterValues = {},
  currentSubcategory,
  currentGroup,
  baseAs = '/',
  baseHrefQuery = {},
  i18n,
  isUserSearch,
  isAuthorized,
  formStyle,
  paginationParams
}) => {
  const router = useRouter()

  const [notification, setNotification] = useState('')

  const items = config.adsList.panelItemsMobile
  const { t } = useTranslation('common')

  const onPanelItemClick = (e) => {
    const key = Number(e.currentTarget.dataset.id)
    const locale = i18n?.lang?.toUpperCase() || 'ME'
    const preparedFilterValues = prepareFilterValues(filterValues)

    // Default sortBy param
    if (!preparedFilterValues.hasOwnProperty('sortBy')) {
      preparedFilterValues.sortBy = 'dateDesc'
    }

    const panelFilter = items[key]

    // set panel filter value or unset if it exists
    if (preparedFilterValues.hasOwnProperty(panelFilter.code)) {
      try {
        if (preparedFilterValues[panelFilter.code] === JSON.parse(panelFilter.value)) {
          delete preparedFilterValues[panelFilter.code]
        } else {
          preparedFilterValues[panelFilter.code] = JSON.parse(panelFilter.value)
        }
      } catch (err) {
        if (preparedFilterValues[panelFilter.code] === panelFilter.value) {
          delete preparedFilterValues[panelFilter.code]
        } else {
          preparedFilterValues[panelFilter.code] = panelFilter.value
        }
      }
    } else {
      try {
        preparedFilterValues[panelFilter.code] = JSON.parse(panelFilter.value)
      } catch (err) {
        preparedFilterValues[panelFilter.code] = panelFilter.value
      }
    }

    // check if other key panel filters are set and remove them
    Object.keys(items).forEach(otherKey => {
      if (Number(otherKey) !== key) {
        const otherPanelFilter = items[otherKey]
        if (preparedFilterValues.hasOwnProperty(otherPanelFilter.code)) {
          try {
            if (preparedFilterValues[otherPanelFilter.code] === JSON.parse(otherPanelFilter.value)) {
              delete preparedFilterValues[otherPanelFilter.code]
            }
          } catch (err) {
            if (preparedFilterValues[otherPanelFilter.code] === otherPanelFilter.value) {
              delete preparedFilterValues[otherPanelFilter.code]
            }
          }
        }
      }
    })

    let actualSubcategorySeo = null

    if (currentSubcategory) actualSubcategorySeo = currentSubcategory.seo
    else actualSubcategorySeo = currentGroup ? currentGroup.seo : null

    const hrefUrl = getSearchHrefUrl()
    const href = {
      pathname: hrefUrl,
      query: {
        ...baseHrefQuery,
        ...preparedFilterValues,
        category: actualSubcategorySeo,
        pageNumber: 1
      }
    }

    const asUrl = getSearchAsUrl(actualSubcategorySeo, baseAs, locale)
    const as = {
      pathname: asUrl,
      query: { ...preparedFilterValues, pageNumber: 1 }
    }

    router.push(href, as)
  }

  const getIsActive = (itemId) => {
    const item = items[itemId]
    let isActive = false

    if (filterValues.hasOwnProperty(item.code)) {
      try {
        if (filterValues[item.code] === JSON.parse(item.value)) {
          isActive = true
        }
      } catch (err) {
        if (filterValues[item.code] === item.value) {
          isActive = true
        }
      }
    }

    return isActive
  }

  const addSavedSearch = async () => {
    setNotification('')

    const preparedFields = prepareFields()

    if (preparedFields) {
      const api = new AdApi()
      const result = await api.addSavedSearch(preparedFields)

      if (result.status === 'ok') {
        setNotification(t('Pretraga sačuvana'))
      }
    }
  }

  const prepareFields = () => {
    const cookies = new CookiesHelper()

    const userId = cookies.get('userId')
    const token = cookies.get('token')

    if (isAuthorized && userId && token) {
      let fields = {}
      if (Object.keys(filterValues).length === 0) return null

      fields = filterValues

      fields.formStyle = formStyle

      fields.userId = userId
      fields.token = token

      if (currentGroup) fields.group = currentGroup.id
      if (currentSubcategory) fields.category = currentSubcategory.id

      return fields
    } else {
      Router.push('/profile', '/profil')
    }
  }

  const renderItem = (key) => {
    const item = items[key]

    if (item.link) {
      const isActive = item.code === 'all-ads' && router.pathname === '/'

      return (
        <Link href={item.link.href} as={item.link.as}>
          <a className={isActive ? 'active' : ''}>
            {item.iconSvg
              ? (
                <ReactSVG src={item.iconSvg} beforeInjection={svg => {
                  svg.setAttribute('style', 'width: 1rem; height: 1rem;')
                }} />
              ) : <i className={`${item.classname} ico`} />
            }
            <span>{t(`common:panelItemsMobile_${item.code}_label`)}</span>
          </a>
        </Link>
      )
    }

    return (
      <a
        href='javascript:void(0)'
        onClick={onPanelItemClick}
        data-id={key}
        className={getIsActive(key) ? 'active' : ''}
      >
        <i className={`${item.classname} ico`} />
        <span>{t(`common:panelItemsMobile_${item.code}_label`)}</span>
      </a>
    )
  }

  return (
    <>
      <div className='oglasi-filter-content-mobile'>
        <ul>
          {Object.keys(items).map(key => <li key={key}>{renderItem(key)}</li>)}
        </ul>
      </div>

      {router?.pathname !== '/' ? (
        <div className='oglasi-filter-ad-count'>
          <p>
            {capitalize(t('common:PRONAĐENO'))} {paginationParams?.totalCount || 0}
          </p>

          <button className='oglasi-filter-save-search' style={{ marginLeft: 'auto' }} onClick={addSavedSearch}>
            <i className='ico-filter-sacuvaj-pretragu ico' />
            <p>{t('common:Sačuvaj pretragu')}</p>
          </button>

          <button className='oglasi-filter-reset-search' onClick={() => { Router.push('/'); }}>
            <ReactSVG
              src='/icons/161.obrisati.svg'
              beforeInjection={svg => {
                svg.setAttribute('style', 'width: 12px; height: 12px;')
              }}
              className='pretraga-reset-filter'
            />
            <p>{t('common:resetSearchVehiclePartsText')}</p>
          </button>
        </div>
      ) : null}

      <Notification
        isActive={!!notification}
        message={notification}
        action={t('Sakrij')}
        onClick={() => { setNotification('') }}
      />
    </>
  )
}

const mapStateToProps = (state, ownProps) => {
  const user = getInfo(state)

  let baseAs = '/'
  let baseHrefQuery = {}

  if (ownProps.isUserSearch && user && user.type && user.username) {
    baseAs = `/${user.type.seo}/${user.seo || user.username}/`
    baseHrefQuery = { username: user.seo || user.username, userType: user.type.seo }
  }

  return {
    currentSubcategory: getCurrentSubCategory(state),
    currentGroup: getCurrentGroup(state),
    baseAs,
    baseHrefQuery,
    paginationParams: getPaginationParams(state),
    isAuthorized: getIsAuthorized(state)
  }
}

PanelMobile.propTypes = {
  baseAs: PropTypes.string,
  baseHrefQuery: PropTypes.object,
  filterValues: PropTypes.object.isRequired,
  formStyle: PropTypes.string,
  currentSubcategory: PropTypes.object,
  currentGroup: PropTypes.object,
  paginationParams: PropTypes.shape({
    totalCount: PropTypes.number
  }).isRequired
}

export default connect(mapStateToProps)(PanelMobile)
